import { Link, useLocation } from 'react-router-dom'
import style from '../../assets/styles/panel.module.scss'

const ReserveItem = (props) => {
    const location = useLocation();
    const data = {
        status: props.statusText ? props.statusText : null,
        statusColor: props.statusColor ? props.statusColor : null,
        link: props.link ? props.link : null,
        r1: props.r1 ? props.r1 : null,
        r2: props.r2 ? props.r2 : null,
        r3: props.r3 ? props.r3 : null,
        l1: props.l1 ? props.l1 : null,
        l2: props.l2 ? props.l2 : null,
        l3: props.l3 ? props.l3 : null,
    }

    return (
        <div className={'border rounded mb-2 ' + (style.ReserveItemBox)} >
            <Link to={data.link}
                state={{ role: location.pathname.split('/').splice(1, 2).join('/') == "panel/Reserves" && "user" }}
                className="row" style={{ textDecoration: "none" }}>
                <div className="col-3 d-flex align-items-center justify-content-center">
                    <div className={style.ReserveStatus} style={{ background: data.statusColor }}>
                        {data.status}
                    </div>
                </div>

                <div className="col">
                    <p>{data.r1}</p>
                    {data.r2 && <p className='my-1'>{data.r2}</p>}
                    <p>{data.r3}</p>
                </div>

                <div className="col-auto">
                    <p style={{ textAlign: "center" }}>{data.l1}</p>
                    <p className='my-1' style={{ textAlign: "center" }} >{data.l2}</p>
                    <p style={{ textAlign: "center" }}>{data.l3}</p>
                </div>
            </Link>
        </div>
    );
}

export default ReserveItem;
